import React, { createContext, useState, useContext } from 'react';

// Création du contexte des paramètres
const SettingsContext = createContext();

// Hook personnalisé pour utiliser le contexte des paramètres
export const useSettings = () => {
  return useContext(SettingsContext);
};

// Fournisseur du contexte des paramètres
export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    language: 'fr',
    currency: 'EUR',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24h',
    notifications: {
      email: true,
      push: true,
      sms: false
    },
    theme: 'light'
  });

  // Fonction pour mettre à jour un paramètre
  const updateSetting = (key, value) => {
    setSettings(prevSettings => ({
      ...prevSettings,
      [key]: value
    }));
  };

  // Fonction pour mettre à jour un paramètre de notification
  const updateNotificationSetting = (key, value) => {
    setSettings(prevSettings => ({
      ...prevSettings,
      notifications: {
        ...prevSettings.notifications,
        [key]: value
      }
    }));
  };

  // Valeur du contexte
  const value = {
    settings,
    updateSetting,
    updateNotificationSetting
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export { SettingsContext };
